module.exports = __webpack_public_path__ + "assets/edit-fb220d451c836f705d6beb2c4ad8ddd6.svg";